
import { defineComponent } from 'vue';
import { IHost, IServiceCode } from '@/types/models';
import api from '@/api/my/serviceCodes';
import utils from '@/utils';
import Buy from './components/serviceCodes/Buy.vue';

interface IState {
  serviceCodes: IServiceCode[];
  isBuy: boolean;
}

export default defineComponent({
  components: {
    Buy,
  },
  data() {
    return {
      serviceCodes: [],
      isBuy: false,
    } as IState;
  },
  methods: {
    apiGet() {
      api.get((res) => {
        this.serviceCodes = res.serviceCodes;
      });
    },

    getUrl(host: IHost): string {
      return utils.getHostUrl(host.hostName, host.nodeName, host.isHongKong);
    },

    getUniqueName(host: IHost) {
      return utils.getHostUniqueName(host);
    },

    btnBuyClick() {
      this.isBuy = true;
    },

    btnBuyCloseClick() {
      this.isBuy = false;
      this.apiGet();
    },
  },
  mounted() {
    this.apiGet();
  },
});
